<template>
  <div class="layout">
    <Header @prevent-scroll="preventContentScroll" />
    <div class="wrapper_content" :class="{ inner: $route.name !== 'intro', non_scroll: preventScroll }">
      <div
        class="content"
        :class="{ inner: $route.name !== 'intro', inner_fnb: hasFnb, policy_footer: hasPolicyFooter }"
        id="content"
      >
        <router-view :isLoaded="isLoaded"></router-view>
      </div>
      <excnange-layer />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/modules/common/Header';
import Footer from '@/components/modules/common/Footer';
import ExcnangeLayer from '@/components/modules/exchange/ExcnangeLayer';
import { addClass, removeClass, setServiceInfo, isLogin, checkUserRegion } from '@/utils';
import { mapActions, mapGetters } from 'vuex';
import { CONTAINED_FNB_ROUTE_NAME_LIST } from '@/consts/consts';

export default {
  components: {
    Header,
    Footer,
    ExcnangeLayer,
  },
  data() {
    return {
      preventScroll: false,
      isLoaded: false,
    };
  },
  computed: {
    ...mapGetters(['serviceInfo']),
    userRegion() {
      return checkUserRegion();
    },
    hasFnb() {
      return CONTAINED_FNB_ROUTE_NAME_LIST.includes(this.$route.name);
    },
    hasPolicyFooter() {
      return this.userRegion === 'krpc' || this.userRegion === 'jppc';
    },
  },
  watch: {
    '$i18n.locale': function () {
      this.init();
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      addClass(document.body, 'scroll_fixed');
    });
  },
  beforeDestroy() {
    removeClass(document.body, 'scroll_fixed');
  },
  methods: {
    ...mapActions(['setPointThumbnailList', 'setPointList']),
    async init() {
      if (isLogin()) {
        await this.setPointThumbnailList();
        await this.setPointList();
      }
      this.isLoaded = true;

      if (this.$route.params.serviceUrl) {
        setServiceInfo(this.$route.params);
      }
    },
    preventContentScroll(value) {
      this.preventScroll = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  .wrapper_content {
    background: #fff;
    &.inner {
      background: #f8f9fa;
      padding-bottom: 100px;
    }
  }
  .content {
    min-height: calc(100vh - 163px);
    background: #f8f9fa;
    &.inner {
      max-width: 1020px;
      background: #f8f9fa;
    }
    &.inner_fnb {
      min-height: calc(100vh - 333px);
      margin-top: 69px;
    }
    &.policy_footer {
      min-height: calc(100vh - 190px);
    }
  }
}

@media all and (max-width: 767px) {
  .wrapper_content {
    &.non_scroll {
      width: 100%;
      position: fixed;
      top: 70px;
      left: 0;
      overflow: hidden;
    }
  }
}

@media all and (max-width: 480px) {
  .layout {
    .content {
      //min-height: calc(100vh - 148px);
      background: #f8f9fa;
      &.inner {
        background: #f8f9fa;
      }
      &.inner_fnb {
        min-height: calc(100vh - 315px);
        margin-top: 52px;
      }
    }
  }
}
</style>
